import React from 'react';

import styles from './LineGraphCard.module.scss';
import StatisticsCard from '../../../../Shared/StatisticsCard/StatisticsCard';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    LineElement,
    Title,
    Tooltip,
    Legend,
    PointElement
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    Legend
);

const options = {
    responsive: true,
    tooltips: {
        intersect: false
    },
    plugins: {
        legend: {
            position: 'top' as const,
        },
        title: {
            display: false,
            text: 'Chart title',
        }
    }
};

function LineGraphCard(props: LineGraphCardProps) {
    return (
        <StatisticsCard
            title={props.title}
        >
            <div className={styles.cardcontent}>
                { props.data != undefined && props.data.datasets.length > 0 ?
                    <Line
                        options={
                            // Merge the default options with the given
                            Object.assign({}, options, props.options)
                        }
                        data={props.data}
                        redraw={true}
                    />
                : null }
                { props.description != undefined ?
                    <p className={styles.description}>{props.description}</p>
                : null }
            </div>
        </StatisticsCard>
    );
}

class LineGraphCardProps {
    title!: string;
    data!: any;
    options?: any;
    description?: string;
}

export default LineGraphCard;